import type { EnvironmentProviders, Provider } from '@angular/core';
import { importProvidersFrom, inject, provideEnvironmentInitializer } from '@angular/core';
import type { Routes } from '@angular/router';
import { Router } from '@angular/router';

import { Actions, ofType, provideEffects } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { CandidatesDataSourceService } from 'domains/recruitee/apps/recruitee/src/app/features/candidate/views/candidates-data-source.service';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { JobActionsFacade } from 'domains/recruitee/apps/recruitee/src/app/features/offers/facades/job-actions.facade';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { OfferActionsFacade } from 'domains/recruitee/apps/recruitee/src/app/features/offers/facades/offer-actions-facade.types';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { ManageEeoBulkService } from 'domains/recruitee/apps/recruitee/src/app/features/offers/offers-page/manage-eeo-bulk/manage-eeo-bulk.service';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { ManageReferralsBulkService } from 'domains/recruitee/apps/recruitee/src/app/features/offers/offers-page/manage-referrals-bulk/manage-referrals-bulk.service';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { OffersBulkActionsExecutorService } from 'domains/recruitee/apps/recruitee/src/app/features/offers/offers-page/offers-bulk-actions-executor.service';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { OffersBulkActionsValidatorService } from 'domains/recruitee/apps/recruitee/src/app/features/offers/offers-page/offers-bulk-actions-validator.service';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { JobsBoardCardComponent } from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/board/card/jobs-board-card.component';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { JobsGroupHeaderComponent } from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/board/group-header/group-header.component';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { ViewsOffersBulkActionsController } from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/bulk-actions/views-offers-bulk-actions.controller';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { OfferListHeadingComponent } from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/offer-list-item/offer-list-heading.component';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { OfferListWrapperComponent } from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/offer-list-item/offer-list-wrapper.component';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { JobsDataSourceService } from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/services/jobs-data-source.service';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { ViewsJobsEffects } from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/services/jobs.effects';
// eslint-disable-next-line boundaries/element-types -- FIXME
import type { OfferTableFields } from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/table-cells/offer-columns';
/* eslint-disable boundaries/element-types */
import {
  offerColumnFieldMap,
  offerColumns,
} from 'domains/recruitee/apps/recruitee/src/app/features/offers/views/table-cells/offer-columns';
/* eslint-enable boundaries/element-types */
// eslint-disable-next-line boundaries/element-types -- FIXME
import { RtPricingFeatureConnectedModule } from 'domains/recruitee/apps/recruitee/src/app/features/pricing/connected/pricing-feature-connected.module';
import { merge, take, tap } from 'rxjs';

import { UserActions } from '@core/account-data';
import type { OfferItem } from '@core/offers-types';
import { RoleActions } from '@core/roles-data';
import { BulkActionsController, BulkActionsSelectionTracker } from '@recruitee/bulk-actions-legacy';
import { DataSourceActions } from '@recruitee/views-data';
import type { TableConfig } from '@recruitee/views-util';
import {
  dataSourceProviders,
  provideBoardLayout,
  provideListLayout,
  provideTableLayout,
  provideViewBaseRoute,
} from '@recruitee/views-util';

const viewsEnvInitialize: Array<Provider | EnvironmentProviders> = [
  provideEnvironmentInitializer(() => {
    const initializerFn = (() => {
      const store = inject(Store);
      const actions$ = inject(Actions);
      const router = inject(Router);

      merge(
        actions$.pipe(
          ofType(DataSourceActions.fetchOneFailed),
          tap(() => router.navigate(['/'])),
        ),
        actions$.pipe(ofType(DataSourceActions.fetchOneSuccess)),
      )
        .pipe(take(1))
        .subscribe();

      return () => {
        store.dispatch(UserActions.fetchCollection());
        store.dispatch(RoleActions.fetchCollection());
      };
    })();
    return initializerFn();
  }),
];

const viewsProviders: Array<Provider | EnvironmentProviders> = [
  CandidatesDataSourceService,
  JobsDataSourceService,
  provideEffects(ViewsJobsEffects),
  dataSourceProviders('jobs', {
    jobs: JobsDataSourceService,
    candidates: CandidatesDataSourceService,
  }),
  provideViewBaseRoute('/views'),

  // To make offer card work
  // { provide: OfferAnalytics, useClass: JobsAnalytics },
  JobActionsFacade,
  { provide: OfferActionsFacade, useExisting: JobActionsFacade },
  provideListLayout({
    jobs: { header: OfferListHeadingComponent, record: OfferListWrapperComponent },
  }),
  provideTableLayout({
    jobs: <TableConfig<OfferItem, OfferTableFields>>{
      tableGroupHeader: OfferListHeadingComponent,
      columns: offerColumns,
      columnFieldMap: offerColumnFieldMap,
    },
  }),
  provideBoardLayout({
    jobs: {
      item: JobsBoardCardComponent,
      groupHeader: JobsGroupHeaderComponent,
    },
  }),
  importProvidersFrom(RtPricingFeatureConnectedModule),
  // Offer bulk actions services
  ViewsOffersBulkActionsController,
  { provide: BulkActionsController, useExisting: ViewsOffersBulkActionsController },
  OffersBulkActionsExecutorService,
  OffersBulkActionsValidatorService,
  ManageEeoBulkService,
  ManageReferralsBulkService,
  BulkActionsSelectionTracker,
];

export const ROUTES: Routes = [
  {
    path: 'prosemirror',
    loadChildren: () => import('../prosemirror/prosemirror.module').then(m => m.ProsemirrorModule),
  },
  {
    path: 'views',
    loadChildren: () =>
      import('@recruitee/views-legacy').then(m =>
        m.provideDataSourceRouting([viewsEnvInitialize, viewsProviders], true),
      ),
  },
  {
    path: 'analytics',
    loadChildren: () => import('@recruitee/reports-smart-ui').then(m => m.REPORTS_ROUTES),
  },
  {
    path: 'job-dashboard',
    loadChildren: () =>
      import('../reports-new-job-dashboard/reports-new-job-dashboard.routing').then(
        m => m.newJobDashboardRoutes,
      ),
  },
  {
    path: 'offer-letters',
    loadComponent: () =>
      import('../offer-letters/offer-letters.component').then(m => m.OfferLettersComponent),
  },
];
